import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const SyncedPlaylistCard = ({ playlist, onManage, onResync }) => {
  const formatLastSync = (date) => {
    const now = new Date();
    const diff = now - date;
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (hours < 1) return 'Recently';
    if (hours < 24) return `${hours}h ago`;
    return `${days}d ago`;
  };

  const getPlatformIcon = (platform) => {
    switch (platform) {
      case 'spotify':
        return 'Music';
      case 'youtube':
        return 'Play';
      default:
        return 'List';
    }
  };

  const getPlatformColor = (platform) => {
    switch (platform) {
      case 'spotify':
        return 'text-success';
      case 'youtube':
        return 'text-error';
      default:
        return 'text-primary';
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-4 shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start space-x-3 mb-3">
        <div className="w-12 h-12 bg-surface-secondary rounded-lg overflow-hidden flex-shrink-0">
          <Image
            src={playlist.coverImage}
            alt={`${playlist.name} cover`}
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-text-primary truncate mb-1">
            {playlist.name}
          </h4>
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Music2" size={12} className="text-text-muted" />
            <span className="text-xs text-text-secondary">
              {playlist.songCount} songs
            </span>
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-1">
              <Icon 
                name={getPlatformIcon(playlist.sourcePlatform)} 
                size={12} 
                className={getPlatformColor(playlist.sourcePlatform)}
              />
              <Icon name="ArrowRight" size={10} className="text-text-muted" />
              <Icon 
                name={getPlatformIcon(playlist.targetPlatform)} 
                size={12} 
                className={getPlatformColor(playlist.targetPlatform)}
              />
            </div>
            <span className="text-xs text-text-muted">
              Synced {formatLastSync(playlist.lastSync)}
            </span>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className={`flex items-center space-x-1 px-2 py-1 rounded-full ${
            playlist.syncStatus === 'up_to_date' ? 'bg-success/10' :
            playlist.syncStatus === 'outdated'? 'bg-warning/10' : 'bg-error/10'
          }`}>
            <div className={`w-1.5 h-1.5 rounded-full ${
              playlist.syncStatus === 'up_to_date' ? 'bg-success' :
              playlist.syncStatus === 'outdated'? 'bg-warning' : 'bg-error'
            }`}></div>
            <span className={`text-xs font-medium ${
              playlist.syncStatus === 'up_to_date' ? 'text-success' :
              playlist.syncStatus === 'outdated'? 'text-warning' : 'text-error'
            }`}>
              {playlist.syncStatus === 'up_to_date' ? 'Up to date' :
               playlist.syncStatus === 'outdated'? 'Outdated' : 'Sync failed'}
            </span>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onResync(playlist.id)}
            iconName="RefreshCw"
            iconSize={14}
          >
            Resync
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onManage(playlist.id)}
            iconName="Settings"
            iconSize={14}
          >
            Manage
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SyncedPlaylistCard;